<div id="int-inventory-main" class="w-full h-full flex flex-col">
  <app-internal-toolbar [title]="'internal.inventory.title' | translate">
    <barcode-scanner-search-field
      center
      class="desktop"
      (onSearch)="searchFilter.set($event)"
      (onCode)="codeScanned($event)"
    ></barcode-scanner-search-field>

    <ng-container actions>
      <reactive-button
        actions
        [label]="'general.refresh' | translate"
        icon="refresh"
        variant="outlined"
        [disabled]="loadingItems()"
        (onClick)="loadInventory()"
      ></reactive-button>

      <div id="printer-status" class="flex items-center ml-4">
        @if (!printerSupported()) {
          <mat-icon
            color="var(--p-red-500)"
            [size]="36"
            [pTooltip]="'internal.inventory.printer.noSupport' | translate"
            tooltipPosition="left"
          >
            print
          </mat-icon>
        }
        @if (printerSupported() && !printerConnected()) {
          <mat-icon
            color="var(--p-neutral-500)"
            class="cursor-pointer"
            [size]="36"
            [pTooltip]="'internal.inventory.printer.notConnected' | translate"
            tooltipPosition="left"
            (click)="connectPrinter()"
          >
            print
          </mat-icon>
        }
        @if (printerSupported() && printerConnected() && !printerPrinting()) {
          <mat-icon
            color="var(--p-green-500)"
            [size]="36"
            [pTooltip]="'internal.inventory.printer.connected' | translate"
            tooltipPosition="left"
          >
            print
          </mat-icon>
        }
        @if (printerSupported() && printerConnected() && printerPrinting()) {
          <mat-icon
            color="var(--p-blue-500)"
            [size]="36"
            [pTooltip]="'internal.inventory.printer.printing' | translate"
            tooltipPosition="left"
          >
            print
          </mat-icon>
        }
      </div>
    </ng-container>
  </app-internal-toolbar>

  <div class="mobile">
    <barcode-scanner-search-field
      center
      (onSearch)="searchFilter.set($event)"
      (onCode)="codeScanned($event)"
    ></barcode-scanner-search-field>
  </div>

  <div
    id="sub-toolbar"
    class="w-full h-16 shrink-0 pl-5 pr-5 flex flex-row gap-2 items-center bg-neutral-800"
  >
    <!-- @if (loadingTransactions()) {
      <p-skeleton height="2.625rem" width="9rem" />
    } @else { -->
      <reactive-button
        [label]="'internal.inventory.showTransactions' | translate"
        icon="receipt_long"
        variant="outlined"
        (onClick)="showTransactions()"
      ></reactive-button>
    <!-- } -->
    <reactive-button
      [label]="'internal.inventory.showMissingItems' | translate"
      icon="rule"
      variant="outlined"
      (onClick)="showMissingItems()"
    ></reactive-button>
    <!-- @if (loadingGroups()) {
      <p-skeleton height="2.625rem" width="9rem" />
    } @else { -->
      <reactive-button
        [label]="'internal.inventory.showGroups' | translate"
        icon="inventory_2"
        variant="outlined"
        (onClick)="showGroups()"
      ></reactive-button>
    <!-- } -->

    <div class="h-3/4 m-2 w-0.5 bg-neutral-900"></div>

    @if (api.hasPermission('inventory_booking')) {
      <reactive-button
        [label]="'internal.inventory.booking' | translate"
        icon="list_alt_add"
        variant="outlined"
        (onClick)="openCreateTransactionDialog()"
      ></reactive-button>
      <reactive-button
        [label]="'internal.inventory.startInventoryCheck' | translate"
        icon="inventory"
        variant="outlined"
        (onClick)="startInventoryCheck()"
      ></reactive-button>
    }
  </div>

  <div id="inv-content">
    <div class="flex flex-col min-h-0" [class.hide]="selectedCategory() != undefined">
      <div class="text-xl font-bold text-center p-4 flex items-center shrink-0" style="height: 74px">
        {{ 'internal.inventory.categories' | translate }}
      </div>
      <div class="flex-1 min-h-0 overflow-y-auto flex flex-col justify-start items-start p-2 gap-2">
        @if (loadingItems()) {
          <p-skeleton height="2.75rem" />
          <p-skeleton height="2.75rem" />
          <p-skeleton height="2.75rem" />
        } @else {
          @for (category of categories(); track category) {
            <div
              class="inv-category shrink-0 flex flex-row justify-start items-center p-2 w-full rounded-sm cursor-pointer"
              [class.active]="category == selectedCategory()"
              (click)="selectCategory(category)"
            >
              <div
                class="text-lg"
                [class.text-muted-color]="searchFilter() != '' && countCategory(category) == 0"
              >
                {{
                  (category == '' ? 'internal.inventory.noCategorySpecified' : category) | translate
                }}

                @if (searchFilter() != '' && countCategory(category) > 0) {
                  <span> ({{ countCategory(category) }}) </span>
                }
              </div>
            </div>
          }
        }
      </div>
    </div>

    <div class="desktop m-1 mt-2 mb-2 w-0.5 bg-neutral-800"></div>

    <div class="flex flex-col min-h-0" [class.hide]="selectedCategory() == undefined">
      <div class="flex items-center p-4 gap-2 shrink-0">
        <p-button
          class="mobile"
          [rounded]="true"
          [text]="true"
          (onClick)="selectCategory(undefined)"
        >
          <mat-icon color="white">arrow_back</mat-icon>
        </p-button>

        <div class="text-xl font-bold">
          {{ 'internal.inventory.items' | translate }}
        </div>

        <div class="h-3/4 ml-auto m-2 w-0.5"></div>

        @if (api.hasPermission('create_inventory_item')) {
          <reactive-button
            [label]="'internal.inventory.newItem' | translate"
            icon="add"
            variant="outlined"
            (onClick)="newItem()"
          ></reactive-button>

          <reactive-button
            [label]="'internal.inventory.newItemBulk' | translate"
            icon="playlist_add"
            variant="outlined"
            (onClick)="newItem(true)"
          ></reactive-button>
        }

        <reactive-button
          [label]="'internal.inventory.deleteItems' | translate"
          icon="delete"
          variant="outlined"
          [disabled]="selectedItems().length == 0"
          (onClick)="deleteSelected()"
        ></reactive-button>
      </div>
      <div class="flex-1 min-h-0 overflow-y-auto flex flex-col justify-start items-start p-2 gap-2">
        @if (loadingItems()) {
          <p-skeleton height="2.5rem" />
          <p-skeleton height="2.5rem" />
          <p-skeleton height="2.5rem" />
        } @else {
          @for (item of filteredItems(); track item) {
            <div
              class="inv-item shrink-0 flex flex-row items-center h-10 gap-2 w-full p-2 rounded-sm cursor-pointer"
              [class.active]="selectedItems().includes(item._id)"
              (click)="openItem(item)"
            >
              <p-checkbox
                [binary]="true"
                [ngModel]="selectedItems().includes(item._id)"
                (onChange)="selectItem(item)"
                (click)="$event.stopPropagation()"
              />
              <div class="text-base">{{ item.name }}</div>
              <div class="ml-4 text-sm text-muted-color">{{ item.additionalInfo }}</div>
            </div>
          } @empty {
            <empty-state
              class="w-full"
              [icon]="'search_off'"
              [title]="'internal.inventory.empty.title' | translate"
              [subtitle]="'internal.inventory.empty.subtitle' | translate"
              [showButton]="true"
              [buttonText]="'internal.inventory.empty.button' | translate"
              (buttonClick)="search?.reset()"
            >
            </empty-state>
          }
        }
      </div>
    </div>
  </div>
</div>
